import { Injectable } from '@angular/core';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ReCaptchaV3Service } from 'ngx-captcha';
import { from, Observable, of } from 'rxjs';
import { timeout } from 'rxjs/operators';

import { ConfigurationService, IProviderShareableLinkAppConfig } from '@sondermind/configuration';
import { Logger } from '@sondermind/datadog-logging';

const RECAPTCHA_TIMEOUT_MS = 5000;

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {
  siteKey: string | null = null;
  useEnterprise: boolean = true;

  constructor(
    public configurationService: ConfigurationService<IProviderShareableLinkAppConfig>,
    public recaptchaV3Service: ReCaptchaV3Service,
    public logger: Logger,
  ) {
    this.siteKey = this.configurationService.env.app?.recaptchaSiteKey || null;
  }

  executeEvent$(eventName: string): Observable<string> {
    if (!this.siteKey) {
      this.logger.warn('No site key found. Recaptcha request could not be sent.');
      return of('');
    }

    // Wrap the external service
    return from(this.recaptchaV3Service.executeAsPromise(
      this.siteKey, eventName, { useEnterprise: this.useEnterprise }
    )).pipe(
      timeout({
        first: RECAPTCHA_TIMEOUT_MS,
        with: () => {
          this.logger.warn('reCAPTCHA timed out — proceeding with empty token', { eventName });
          return of('');
        }
      })
    );
  }
}
